import React from 'react';

import BlogHeader from 'sections/blog/BlogHeader';
import BlogListTop from 'sections/blog/BlogListTop';
import ContactSection from 'sections/landing/ContactSection';
import { SEO, buildBreadcrumb } from 'hooks/useSeo';
import { PageUrl } from 'const/page-url';
import { ARTICLE_META } from 'const/blog';
import { buildArticleListJsonLd } from 'const/blog/jsonLd';

// ==============================|| BLOG LIST PAGE ||============================== //
//
// お役立ち記事の一覧(/blog)。
//
// 検索から記事に直接着地する人がほとんどで、この一覧が入口になることは少ない。
// それでも一覧を用意しているのは、
//   - 記事どうしをつなぐ受け皿が必要なため(記事 → 一覧 → 別の記事)
//   - クローラーが新しい記事に到達する経路になるため
//   - ビルド時に記事の一覧を取り出す場所として使っているため(scripts/prerender.js)
// という3つの理由による。

// 画面の h1(sections/blog/BlogListTop.tsx)と構造化データの name をそろえるための見出し。
// 検索結果に出る名前と、開いたページの見出しが食い違わないようにする。
const HEADING = '児発・放デイの運営お役立ち記事';

// meta description。一覧に並んでいる記事の中身と揃える。
// 加算の記事はまだ無く、いま並んでいるのは個別支援計画と減算なので、そこを書く。
const DESCRIPTION =
    '児童発達支援・放課後等デイサービスの運営に役立つ情報をまとめています。個別支援計画の書き方と記載例、減算の要件と減算率、運営指導で確認される記録の残し方など、児発管・管理者が実務で迷いやすい点を、条文と通知の原文つきで解説します。';

const Blog: React.FC = () => {
    return (
        <React.Fragment>
            <SEO
                title={`${HEADING} | OHANA AI`}
                description={DESCRIPTION}
                path={PageUrl.Blog.urlWithSlash}
                jsonLd={[
                    buildBreadcrumb([{ name: 'お役立ち記事', path: PageUrl.Blog.urlWithSlash }]),
                    // 一覧に何が載っているか(ItemList)を伝える。カテゴリ一覧と同じ組み立てを使う。
                    // 並び順は画面の並び(ARTICLE_META の順)と同じにする
                    buildArticleListJsonLd({ heading: HEADING, description: DESCRIPTION }, ARTICLE_META, PageUrl.Blog.urlWithSlash)
                ]}
            />
            <BlogHeader />
            <BlogListTop />
            <ContactSection to="/" />
        </React.Fragment>
    );
};

export default Blog;
